import React from 'react';

import { Pressable, View } from 'react-native';

import { SvgProps } from 'react-native-svg';

import { PlayerTrack } from 'store/player/reducer.types';

import { COLOR } from 'utils/colors';
import { isWeb } from 'utils/responsiveness';

import Text, { ETextCategory, ETextColor } from 'components/Text';

import useAudioAndSubtitleOption from '../../../hooks/useAudioAndSubtitleOption';
import styles from './styles';

type Props = {
    item: PlayerTrack;
    SvgRightImage?: React.ComponentType<SvgProps> | null;
    onPress(track: PlayerTrack): void;
    isSelected: boolean;
    isAudio?: boolean;
};

function SelectionOption({
    item,
    SvgRightImage,
    onPress,
    isSelected,
    isAudio = false,
}: Props) {
    const { optionName, onPress: handlePress } = useAudioAndSubtitleOption({
        item,
        onPress,
        isAudio,
    });

    return (
        <Pressable
            style={({ pressed }) => [
                pressed && styles.passed,
                styles.container,
            ]}
            accessibilityLabel={optionName}
            aria-selected={isSelected}
            onPress={handlePress}
        >
            <Text
                style={styles.option}
                category={ETextCategory.body2}
                color={isSelected ? ETextColor.neutral : ETextColor.dark_grey}
                aria-hidden={isWeb}
            >
                {optionName}
            </Text>
            <View style={styles.rightContainer}>
                {SvgRightImage && (
                    <SvgRightImage
                        style={styles.rightImage}
                        fill={COLOR.NEUTRAL}
                    />
                )}
            </View>
        </Pressable>
    );
}

export default SelectionOption;
